<script setup lang="ts">
// Aviso de fase beta no topo da página de níveis. Não é dispensável de
// propósito: enquanto o programa estiver mudando, o recado tem que estar
// visível em toda visita — um "fechar" faria ele sumir pra sempre justo pra
// quem mais usa a tela.
</script>

<template>
  <div
    class="flex items-center gap-1.5 rounded-xl px-2 py-2.5 sm:gap-4 sm:px-4 sm:py-3"
    role="note"
    style="
      background: linear-gradient(
        112deg,
        rgb(0 42 144 / 55%),
        rgb(0 24 88 / 55%)
      );
      box-shadow: inset 0 0 0 1px rgb(92 104 255 / 35%);
    "
  >
    <span
      class="flex-none rounded-full px-1.5 py-[2px] text-[8px] font-bold leading-[10px] tracking-[0.06em] text-white sm:px-3 sm:py-1 sm:text-[11px] sm:leading-[14px]"
      style="
        background: linear-gradient(
          160deg,
          rgb(60 95 255) 0%,
          rgb(31 42 214) 100%
        );
        box-shadow: 0 0 14px rgb(60 91 255 / 45%);
      "
    >
      BETA
    </span>

    <p
      class="min-w-0 flex-1 text-[10px] leading-[14px] text-white/[0.78] sm:text-[13.5px] sm:leading-[19px]"
    >
      O sistema de níveis está em
      <strong class="font-bold text-white">fase beta</strong>. Níveis, tiers,
      recompensas e regras podem mudar enquanto evoluímos o programa.
    </p>
  </div>
</template>
